// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2AKn-","row":"Node_row__oTEXh","label":"Node_label__27DWY","footer":"Node_footer__ML1kc"};